var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWavetickicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1398 1.0227C13.0375 -0.340899 10.9586 -0.340899 9.85629 1.0227C9.17142 1.86993 8.05151 2.23381 6.99945 1.95094C5.30619 1.49567 3.62427 2.71765 3.53402 4.46873C3.47794 5.5567 2.78579 6.50936 1.76839 6.8989C0.130914 7.52585 -0.511521 9.50306 0.444715 10.9728C1.03884 11.8859 1.03884 13.0635 0.444715 13.9766C-0.511521 15.4463 0.130914 17.4235 1.76839 18.0505C2.78579 18.44 3.47794 19.3927 3.53402 20.4806C3.62427 22.2317 5.30619 23.4537 6.99945 22.9984C8.05151 22.7156 9.17142 23.0794 9.85629 23.9267C10.9586 25.2903 13.0375 25.2903 14.1398 23.9267C14.8247 23.0794 15.9446 22.7156 16.9966 22.9984C18.6899 23.4537 20.3718 22.2317 20.4621 20.4806C20.5182 19.3927 21.2103 18.44 22.2277 18.0505C23.8652 17.4235 24.5076 15.4463 23.5514 13.9766C22.9572 13.0635 22.9572 11.8859 23.5514 10.9728C24.5076 9.50306 23.8652 7.52585 22.2277 6.8989C21.2103 6.50936 20.5182 5.5567 20.4621 4.46873C20.3718 2.71765 18.6899 1.49567 16.9966 1.95094C15.9446 2.23381 14.8247 1.86993 14.1398 1.0227ZM19.7385 9.36707L17.6956 6.99086L9.82372 13.7569L7.41356 10.6963L4.95123 12.6345L9.38556 18.2679L19.7385 9.36707Z",
    fill: "#00AE4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavetickicon);
export default __webpack_public_path__ + "static/media/wave tick icon.ade1425a15f4a703fcb2cdb05a4e00b2.svg";
export { ForwardRef as ReactComponent };